import QA from "@components/CaseStudyComponents/QA";
import { FC } from "react";
import About from "../../components/CaseStudyComponents/About";
import Aside from "../../components/CaseStudyComponents/Aside";
import Quote from "../../components/CaseStudyComponents/Quote";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import Signup from "../../components/CaseStudyComponents/Signup";
import NewLayout from "../../components/new-ui/Layout";

const PropLeaf: FC = () => {
    //     const data = ["data1", "data2", "data3", "data4", "data5", "data6", "data7", "data8", "data9"];

    // for (let i = 0; i < 9; i++) {
    //   let pageData = [];
    //   for (let j = 0; j < 4; j++) {
    //     let index = (i * 4 + j) % 9;
    //     pageData.push(data[index]);
    //   }
    //   console.log(`Page ${i + 1}: ${pageData.join(", ")}`);
    // }
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout title="CurioEd - Case Study | Gallabox" description="CurioEd increases their engagement rate by 40%." canonical="https://gallabox.com/case-study/curioed">
            <div style={{ backgroundImage: "url('https://assets.gallabox.com/gb-home/case-study/')" }} className="mt-10">
                <div
                    style={{
                        width: "100vw",
                        // height: "65vh",
                        backgroundImage: "url('https://assets.gallabox.com/gb-home/case-study/blue-bg-pattern.png')",
                        backgroundRepeat: "no-repeat",
                    }}
                    className="grid place-items-center mt-1  md:mt-20 mb-10"
                >
                    <div className=" mx-auto m-0 ">
                        <iframe
                            className="propleaf-video-cont"
                            style={{ borderRadius: "2em" }}
                            src="https://www.youtube.com/embed/uWB8d93AZy8"
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        ></iframe>
                    </div>
                </div>
            </div>
            <h1 className="hidden">CurioEd</h1>
            <div className=" max-w-6xl sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <div className="flex flex-col max-w-6xl mx-auto sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "CurioEd",
                                },
                                {
                                    title: "Industry",
                                    content: "E-learning",
                                },
                                {
                                    title: "Employees",
                                    content: "50",
                                },
                                {
                                    title: "Product used",
                                    content: ["WhatsApp chatbot", "Integration", "WhatsApp Broadcast", "Shared Team Inbox"],
                                },
                                {
                                    title: "Automated Chats Per Month",
                                    content: "1k",
                                },
                                {
                                    title: "Website",
                                    link: "www.curioed.com",
                                    content: "curioed.com",
                                },
                            ]}
                        />
                    </div>
                    <main className="basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/curioed/curioed-logo.png"}
                            aboutTitle={"CurioEd"}
                            aboutContent={
                                "CurioEd is an e-learning provider that helps students learn science through projects and experiments with monthly learning kits and live, 1-1, online classes with top academic mentors. We believe that students can get the best learning experience if they experiment things real-time. For example, if a kid wants to learn Robotics, we provide them with kits that have microchips, connectors, resistors, etc., where a mentor is available to teach the basic concepts."
                            }
                        />
                        <Quote
                            quoteText={
                                "“Our open rate on emails was less than 1%. After using WhatsApp automation from Gallabox, the engagement on WhatsApp messages was great. Our message open rate touched 40%”"
                            }
                            quoteBy={"- Sumit Sharma,"}
                            position={"Product Manager at CurioEd"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <QA
                            li={[
                                `<span class="nxt-wave-impact-para block mb-6" style="line-height: 34px;">When we started our journey, we realized that our sales and marketing departments needed some optimization. Emails and messages were our primary channel of communication but our leads and customers hardly responded to our messages. With WhatsApp being the best channel for communication, we adopted the WhatsApp business automation solution provided by Gallabox.</span>
                                <span class="nxt-wave-impact-para"  style="line-height: 34px;">
                                Ever since we started using Gallabox, our engagement with customers improved a lot. We started off with automating our sales and marketing messages with Gallabox and slowly adopted it for our operational activities too. Using Gallabox, we send updates about class schedules, daily reminders, etc., to our customers.
                                </span>`,
                            ]}
                            question={"What were the challenges you had before using Gallabox? "}
                        />
                        <Quote
                            quoteText={
                                "“The platform connects with almost every tool that we use. All we had to do is just create the templates and set the triggers, and our messages automatically go out to customers”"
                            }
                            quoteBy={"- Sumit Sharma,"}
                            position={"Product Manager at CurioEd"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <QA
                            li={[
                                `<li class="nxt-wave-impact-para leading-10 my-4">
                                We use Gallabox for escalations from parents, who are our ideal customers, i.e., whenever a parent sends queries, the response from our end should go instantly. But this was not possible before we had Gallabox in place. Now, we have created a workflow in Gallabox that takes care of all the queries that come from our customers. The chatbot assigns the chats to cross-functional teams based on what the query is about. If it is a course purchase inquiry, it assigns the chat to the sales team, if there is any issue when a student is learning the course, the chatbot automatically pushes the query to the operational team.
                                </li>`,
                                `<li class="nxt-wave-impact-para leading-10 my-4">
                                The tech part of Gallabox is amazing! The platform just connects with almost every platform we use. All we had to do is just create the templates and set the triggers. The messages started going out automatically when the trigger conditions match. This has made our lives really easy.
                                </li>`,
                            ]}
                            question={"Which features in Gallabox do you find useful for your business? "}
                        />
                        <Quote
                            quoteText={
                                "“Irrespective of the size of your business, if you’re trying to efficiently communicate with your customers, Gallabox is the right tool for you”"
                            }
                            quoteBy={"- Sumit Sharma,"}
                            position={"Product Manager at CurioEd"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <QA
                            li={[
                                `<li class="nxt-wave-impact-para my-4">
                                It is very important for a business to communicate with customers at every point in time, starting from prospecting to sales, marketing and transactional processes. Earlier, we used to send out every update via emails and our open rate was less than 1%. After using Gallabox, the open rate was close to 40%. Our engagement rate improved to a larger extent which also contributed to an increase in revenue.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                The entire Gallabox platform is very effective and easy to use. And the Gallabox team is very flexible and helpful to all our queries.
                                </li>`,
                            ]}
                            question={"How has your business benefitted from using Gallabox? "}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default PropLeaf;
